// © Microsoft Corporation. All rights reserved.
/**
 * Checks if the DOM is available to access and use.
 * If you want to distinguish between server side rendering and client side rendering, prefer use `__WEBPACK_IS_NODE__` because it's a constant value that can be optimized by webpack.
 * @returns {boolean} - true if DOM is available, or false if it is not. This is typically true for
 * client side rendering and false for server side rendering.
 */
export function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement && !window.isRenderServiceEnv);
}
//# sourceMappingURL=DOMHelpersCore.js.map